<button
  [@color]="getColor()"
  mat-raised-button
  [matTooltip]="getTooltip()"
  matTooltipPosition="right"
>
  {{ getLabel() }}
</button>
